<!--
 * @Author: Lemon C
 * @Date: 2024-04-29 12:26:45
 * @LastEditTime: 2025-11-14 13:15:13
-->
<template>
    <div class="sup-example-md">
        <span class="body-title" v-if="docs_content_type !== $globalObj.docs_content_type.md">调用示例</span>
        <div
            :class="`example-md-box ${docs_content_type !== $globalObj.docs_content_type.md ? 'example-md-box-top' : ''}`"
            @click="md_handle_link_click">
            <md-preview
                ref="ref_md"
                :editorId="md_preview_id"
                :modelValue="content"
                previewTheme="github"
                :codeFoldable="false"
                :onGetCatalog="extractTagsAnchor" />
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch } from 'vue';
import { MdPreview } from 'md-editor-v3';
import 'md-editor-v3/lib/preview.css';
import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '@/stores/message';
import { useDialogStore } from '@/stores/dialog';

const dialog_store = useDialogStore();
const router_store = useRouterStore();
const message_store = useMessageStore();

const props = defineProps({
    docs_content_type: Number,
    md_content: String, // md内容
    update_md_data: Function, //内容更新
});

const md_preview_id = ref('preview-only');
const ref_md = ref(null);
const content = ref('');
const tagAnctorTree = ref([]); // 标签锚点树

watch(
    () => props.md_content,
    (val) => {
        content.value = props.md_content;
    }
);

onMounted(() => {
    content.value = props.md_content;
});

// MARK MD 提取标签锚点
const extractTagsAnchor = (anctorList) => {
    const stack = [];
    tagAnctorTree.value = [];
    anctorList.forEach((header) => {
        const level = header.level;
        const name = header.text;
        const anchorId = header.text;

        const newNode = { level, name, anchorId, children: [] };

        // 构建树状结构
        while (stack.length > 0 && stack[stack.length - 1].level >= level) {
            stack.pop();
        }
        if (stack.length > 0) {
            stack[stack.length - 1].children.push(newNode);
        } else {
            tagAnctorTree.value.push(newNode);
        }
        stack.push(newNode);
    });
    props.update_md_data(tagAnctorTree.value);
};

// MARK MD 处理链接点击
const md_handle_link_click = (event) => {
    const target = event.target;
    if (target.tagName === 'A') {
        event.preventDefault(); // 阻止默认的链接跳转行为
        const href = target.getAttribute('href');
        if (href.endsWith('.mp4')) {
            if (href.includes('Videos')) {
                dialog_store.showVideoDialog(href);
            }
        } else {
            router_store.navigateToLinkHref(href, (query) => {
                message_store.sendMessage(message_store.M_E_TREE_AUTO_SEL, { treeId: query.treeId });
            });
        }
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-example-md {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: left;

    .body-title {
        position: relative;
        height: 29px;
        font-weight: 600;
        font-size: 20px;
        color: var(--color-main-text-primary);
        line-height: 29px;
    }

    :deep(.example-md-box) {
        position: relative;
        max-width: 100%;

        .md-editor-code-head {
            background-color: var(--color-main-md-code-bg) !important;
        }

        .md-editor-code pre code {
            background-color: var(--color-main-md-code-bg) !important;
        }

        .md-editor ::-webkit-scrollbar {
            width: var(--scrollbar-width);
        }

        .md-editor ::-webkit-scrollbar-track {
            background-color: var(--color-main-scrollbar-track-white);
            border-radius: unset;
        }

        .md-editor ::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: var(--color-main-scrollbar-thumb);
            box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
            -webkit-box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
        }
    }

    // .example-md-box-top {
    //     margin-top: 16px;
    // }
}
</style>
